import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { FaStar } from "react-icons/fa";
import Banner1 from "../../assets/images/S1.png";
import Banner2 from "../../assets/images/S2.png";
import Banner3 from "../../assets/images/S3.png";
import Banner4 from "../../assets/images/S4.png";
import residentIcon from "../../assets/images/Resident_Reviews.png";
import deliveryIcon from "../../assets/images/Delivery_Reviews.png";

function HeroSection({ onContactClick, residentRating, deliveryRating }) {
  return (
    <section className="w-full flex items-center justify-center px-4 lg:h-[710px] overflow-hidden">
      <div className="w-full max-w-[1473px] mx-auto flex flex-col lg:flex-row justify-center lg:justify-between items-center gap-4 sm:gap-6 lg:gap-0 lg:h-[610.03px] px-4">

        {/* Left Container */}
        <div className="w-full lg:w-[829px] flex flex-col justify-between gap-3 sm:gap-4">
          <div className="w-full flex justify-center text-center pt-[30px] sm:pt-[40px] lg:pt-0 lg:block lg:text-left">
            <p className="font-alata text-[16px] lg:text-[20px] leading-[24px] lg:leading-[27.5px] bg-gradient-to-r from-transparent via-[#DBFFEB] to-transparent inline-block px-4">
              Secure, Efficient, and Seamless Parcel Management.
            </p>
          </div>

          <h3 className="font-alata text-[20px] sm:text-[24px] lg:text-[40px] leading-[30px] sm:leading-[36px] lg:leading-[69px] text-center lg:text-left mt-1 sm:mt-2">
            You Explore like a Whale,<br /> We’ll handle your mail.
          </h3>

          {/* Buttons */}
          <div className="banner_btns py-2 sm:py-3 flex flex-wrap gap-2 sm:gap-3 justify-center md:justify-center lg:justify-start">
            <button
              onClick={onContactClick}
              className="bg-[#2699FF] text-white text-[14px] sm:text-[16px] lg:text-[19px] uppercase font-alata rounded-full py-2 px-6"
            >
              Contact Us
            </button>

            {/* ✅ Play Demo button */}
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                const element = document.getElementById("demo-video");
                if (element) {
                  element.scrollIntoView({ behavior: "smooth" });
                }
              }}
              className="border border-[#D1D1D1] text-[14px] sm:text-[16px] lg:text-[19px] font-medium uppercase text-black rounded-full py-2 px-4 flex items-center gap-2"
            >
              <i className="bi bi-play-circle-fill text-[#2699FF]" />
              Play Demo
            </a>
          </div>

          {/* Ratings */}
          <div className="w-full flex justify-center md:justify-center lg:justify-start mt-3 sm:mt-4">
            <div className="flex flex-col md:flex-row gap-3 sm:gap-[16.61px] w-full max-w-[515.56px] md:items-center md:justify-center lg:justify-start">

              {/* Resident Reviews */}
              <div className="flex w-full md:w-[248.23px] h-[80px] sm:h-[85.05px] bg-white rounded-lg shadow-sm items-center px-[15px] sm:px-[17.96px] py-[10px] sm:py-[14.96px] gap-[12px] sm:gap-[16px] border-t-[2.5px] border-[#34A853]">
                <div className="w-[50px] sm:w-[55.63px] h-[50px] sm:h-[58.12px] flex-shrink-0">
                  <img
                    src={residentIcon}
                    alt="Resident"
                    className="w-full h-full object-contain"
                  />
                </div>
                <div className="flex flex-col flex-1 justify-between">
                  <p className="text-[12px] font-semibold leading-[12px]">
                    Resident Reviews
                  </p>
                  <div className="flex items-center gap-1 text-[#FBBF24]">
                    <span className="text-[14px] font-bold text-black">
                      {residentRating}
                    </span>
                    {[...Array(5)].map((_, i) => (
                      <FaStar key={i} className="w-[14px] h-[14px]" />
                    ))}
                  </div>
                  <p className="text-[11px] text-gray-500 leading-[11px]">
                    See all residents reviews
                  </p>
                </div>
              </div>

              {/* Delivery Reviews */}
              <div className="flex w-full md:w-[250.72px] h-[80px] sm:h-[85.05px] bg-white rounded-lg shadow-sm items-center px-[15px] sm:px-[17.96px] py-[10px] sm:py-[14.96px] gap-[12px] sm:gap-[16px] border-t-[2.5px] border-[#34A853]">
                <div className="w-[50px] sm:w-[55.63px] h-[50px] sm:h-[58.12px] flex-shrink-0">
                  <img
                    src={deliveryIcon}
                    alt="Delivery"
                    className="w-full h-full object-contain"
                  />
                </div>
                <div className="flex flex-col flex-1 justify-between">
                  <p className="text-[12px] font-semibold leading-[12px]">
                    Delivery Reviews
                  </p>
                  <div className="flex items-center gap-1 text-[#FBBF24]">
                    <span className="text-[14px] font-bold text-black">
                      {deliveryRating}
                    </span>
                    {[...Array(5)].map((_, i) => (
                      <FaStar key={i} className="w-[14px] h-[14px]" />
                    ))}
                  </div>
                  <p className="text-[11px] text-gray-500 leading-[11px]">
                    See all delivery partner reviews
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Container - Carousel */}
        <div
          className="relative overflow-hidden mx-auto mt-4 sm:mt-6 lg:mt-[36px]"
          style={{
            width: "100%",
            maxWidth: "547.42px",
            height: "480px",
            gap: "72.88px",
          }}
        >
          <div className="w-full overflow-hidden" style={{ height: "400px" }}>
            <Swiper
              modules={[Autoplay, Pagination]}
              spaceBetween={20}
              slidesPerView={1}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              loop={true}
              pagination={{
                clickable: true,
                el: ".custom-swiper-pagination",
              }}
              style={{ width: "100%", height: "100%" }}
            >
              {[Banner1, Banner2, Banner3, Banner4].map((banner, idx) => (
                <SwiperSlide key={idx}>
                  <div className="w-full h-full flex items-center justify-center overflow-hidden">
                    <img
                      src={banner}
                      alt={`Banner ${idx + 1}`}
                      className="w-full h-full object-contain px-2 md:px-0"
                      style={{ maxWidth: "100%", maxHeight: "100%" }}
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>

          <div
            className="custom-swiper-pagination absolute"
            style={{
              bottom: "8px",
              left: 0,
              right: 0,
              display: "flex",
              justifyContent: "center",
            }}
          />
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
